import { render, staticRenderFns } from "./sidebar-list-item.vue?vue&type=template&id=999949a6&scoped=true&"
import script from "./sidebar-list-item.vue?vue&type=script&lang=js&"
export * from "./sidebar-list-item.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-list-item.vue?vue&type=style&index=0&id=999949a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999949a6",
  null
  
)

export default component.exports